import { MoonIcon, SunIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useT } from '@/lib/i18n';
import { useTheme } from './theme-provider';

/**
 * Light / dark toggle — the kit's header `theme-switch`: one click flips,
 * showing the mode you would switch TO (moon while light, sun while dark).
 *
 * It was a light/dark/system dropdown. The kit's single click is better here
 * because the third option is not equal to the other two: `system` is a
 * preference you set once, not something you flick between, and it stays
 * available in Settings → Appearance along with the colour preset. Toggling
 * from `system` commits to the opposite of whatever the OS is currently
 * resolving to, which is what someone reaching for this control means.
 */
export function ThemeSwitch() {
  const { resolvedMode, setMode } = useTheme();
  const t = useT();
  const next = resolvedMode === 'dark' ? 'light' : 'dark';

  // No tooltip wrapper: this control also renders on the login screen, which
  // is outside the console's TooltipProvider. The label carries the meaning.
  return (
    <Button
      variant="ghost"
      size="icon"
      // Two whole keys rather than one with a `{mode}` placeholder: an Arabic
      // sentence does not necessarily put the word where English does, and a
      // half-translated label is the classic result of interpolating an
      // untranslated noun.
      aria-label={t(next === 'dark' ? 'chrome.themeToDark' : 'chrome.themeToLight')}
      onClick={() => setMode(next)}
    >
      {resolvedMode === 'dark' ? <SunIcon className="size-4" /> : <MoonIcon className="size-4" />}
    </Button>
  );
}
